export const DEAL_PROPOSAL_FETCH_REQUEST = 'DEAL_PROPOSAL_FETCH_REQUEST';
export const DEAL_PROPOSAL_FETCH_SUCCESS = 'DEAL_PROPOSAL_FETCH_SUCCESS';
export const DEAL_PROPOSAL_FETCH_FAILURE = 'DEAL_PROPOSAL_FETCH_FAILURE';
export const GET_DEAL_PROPOSAL = 'GET_DEAL_PROPOSAL';
